// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M12,2c-4.9,0-9.1,3.6-9.9,8.4s2.1,9.5,6.7,11.1c0.5,0.1,0.7-0.2,0.7-0.5s0-0.9,0-1.7C6.7,19.9,6.1,18,6.1,18
		C6,17.4,5.5,16.8,5,16.5c-0.9-0.6,0.1-0.6,0.1-0.6c0.6,0.1,1.2,0.5,1.5,1c0.6,1,1.9,1.4,2.9,0.8c0-0.5,0.3-1,0.6-1.3
		c-2.1-0.2-4.5-1.1-4.5-4.9c0-1,0.3-2,1-2.7C6.3,7.9,6.4,7,6.7,6.2c0,0,0.8-0.3,2.8,1c1.6-0.4,3.4-0.4,5,0c1.9-1.3,2.7-1,2.7-1
		c0.4,0.8,0.4,1.8,0.1,2.6c0.7,0.7,1,1.7,1,2.7c0,3.8-2.3,4.7-4.6,4.9c0.5,0.5,0.7,1.2,0.7,1.9c0,1.3,0,2.4,0,2.8s0.2,0.6,0.7,0.5
		c4.7-1.5,7.5-6.2,6.7-11.1S16.9,2,12,2z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-github-BBz_ZPtW.js.map
